import React from 'react';
import { useNavigate } from 'react-router-dom';
import { LayoutDashboard, FileCheck, AlertTriangle, ScanSearch, Send, BookOpen, Plug, Sliders, ArrowRight, FileText } from 'lucide-react';
const allPages = [{
  group: 'Main',
  items: [{
    label: 'Dashboard',
    path: '/dashboard',
    icon: LayoutDashboard,
    description: 'Overview of audit recovery performance'
  }, {
    label: 'Checks',
    path: '/checks',
    icon: FileCheck,
    description: 'All retailer check batches'
  }, {
    label: 'Check Detail — DG-8821',
    path: '/checks/2',
    icon: FileText,
    description: 'Individual deductions for Dollar General #DG-8821'
  }, {
    label: 'Needs Review',
    path: '/friction',
    icon: AlertTriangle,
    description: 'Claims flagged for manual review'
  }, {
    label: 'Mailbox',
    path: '/outbox',
    icon: Send,
    description: 'Outgoing dispute emails'
  }, {
    label: 'Ledger',
    path: '/ledger',
    icon: BookOpen,
    description: 'Full transaction ledger'
  }]
}, {
  group: 'AI Audit',
  items: [{
    label: 'AI Audit — DG-8821',
    path: '/workbench',
    icon: ScanSearch,
    description: 'High confidence mismatch — auto reviewed'
  }, {
    label: 'AI Audit — DG-8824',
    path: '/workbench-review',
    icon: ScanSearch,
    description: 'Low confidence — needs human review'
  }]
}, {
  group: 'Settings',
  items: [{
    label: 'Integrations',
    path: '/settings/integrations',
    icon: Plug,
    description: 'Connect ERP, BOL, and other data sources'
  }, {
    label: 'Rules',
    path: '/settings/rules',
    icon: Sliders,
    description: 'Configure dispute automation rules'
  }]
}];
export function NavTemp() {
  const navigate = useNavigate();
  return <div className="space-y-8 max-w-3xl" data-id="element-805">
      <div data-id="element-806">
        <h2 className="text-2xl font-bold text-slate-900 tracking-tight" data-id="element-807">
          Navigation (temp)
        </h2>
        <p className="text-slate-500 mt-1" data-id="element-808">
          Quick access to all pages in the app.
        </p>
      </div>

      {allPages.map(group => <div key={group.group} data-id="element-809">
          <h3 className="text-xs font-semibold text-slate-400 uppercase tracking-wider mb-3" data-id="element-810">
            {group.group}
          </h3>
          <div className="space-y-2" data-id="element-811">
            {group.items.map(item => <button key={item.path} onClick={() => navigate(item.path)} className="w-full flex items-center justify-between p-4 bg-white rounded-xl border border-slate-200 hover:border-slate-300 hover:shadow-sm transition-all duration-150 text-left group" data-id="element-812">
                <div className="flex items-center gap-4" data-id="element-813">
                  <div className="p-2 rounded-lg bg-slate-100 group-hover:bg-slate-200 transition-colors" data-id="element-814">
                    <item.icon className="w-4 h-4 text-slate-600" data-id="element-815" />
                  </div>
                  <div data-id="element-816">
                    <div className="font-medium text-slate-900 text-sm" data-id="element-817">
                      {item.label}
                    </div>
                    <div className="text-xs text-slate-500 mt-0.5" data-id="element-818">
                      {item.description}
                    </div>
                  </div>
                </div>
                <ArrowRight className="w-4 h-4 text-slate-300 group-hover:text-slate-500 group-hover:translate-x-0.5 transition-all" data-id="element-819" />
              </button>)}
          </div>
        </div>)}
    </div>;
}